import React from 'react';
import '../styles/Footer.css';
import pagamentos from '../assets/images/formasdepagamento.png';
import selo from '../assets/images/selo.png';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Informações de Contato */}
        <div className="footer-contact footer-section">
          <h4>Contato</h4>
          <p>
            <span className="bold-footer">Telefone:</span> (51) 3342-2152<br />
            <span className="bold-footer">WhatsApp:</span> (51) 98342-2322
          </p>
          <p>
            cr.mesquita@terra.com.br
          </p>
          <p>
           Av. Maranhão, 48 - São Geraldo<br />
            Porto Alegre/RS | CEP: 90230-040
          </p>
        </div>

        {/* Links Rápidos */}
        <div className="footer-section">
          <h4>Links rápidos</h4>
          <ul>
            <li><a href="/sobre-nos">Sobre Nós</a></li>
            <li><a href="/politica-de-privacidade">Política de Privacidade</a></li>
            <li><a href="/termos-de-uso">Termos de Uso</a></li>
          </ul>
        </div>

        {/* Formas de Pagamento */}
        <div className="footer-section footer-payment">
          <h4>Formas de pagamento</h4>
          <div className="payment-logos">
            <img src={pagamentos} alt="Formas de pagamento" className="payment-image" />
          </div>
        </div>

        {/* Horário de atendimento */}
        <div className="footer-section footer-hours">
          <h4>Horário de atendimento</h4>
          <ul>
            <li>Segunda a Quinta:<br />7h30 às 12h | 13h05 às 17h30</li>
            <li>Sexta-feira: <br />7h30 às 12h | 13h05 às 16h55</li>
          </ul>
        </div>

        {/* Selo de 50 anos */}
        <div className="footer-section">
          <img src={selo} alt="Selo de 50 anos" className="footer-selo" />
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} CR Mesquita. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;